import "./App.css";
import ChatWidget from "./components/chat";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import clevertap from "clevertap-web-sdk";
import { BE_API_URL, PREVIEW_APP_ID } from "./Config/chatProps";
import PageNotFound from "./components/Invalidpage";

// const CLEVERTAP_ACCOUNT_ID = "K59-Z87-WR7Z";
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

// Get specific params
const platform = urlParams.get("platform");

// Fire GA event based on platform
if (platform && (platform === "web" || platform === "app")) {
  window.parent.postMessage(
    {
      type: "message",
      data: {
        eventName: `budget_bot_26_impression_${platform}`,
      },
    },
    "*"
  );
}


if (urlParams.get("chaticon") === "true") {
  window.parent.postMessage(
    {
      type: "message",
      data: {
        eventName: "budget_bot_26_impression_widget",
      },
    },
    "*"
  );
} else {
  window.parent.postMessage(
    {
      type: "message",
      data: {
        eventName: "budget_bot_26_impression_fullpage",
      },
    },
    "*"
  );
}

// window.parent.postMessage({ type: "message", data: {
//   eventName:"BotInitiated",
// } }, "*");

function App() {
  const [isValid, setIsValid] = useState(false);
  const [appIdProp, setAppIdProp] = useState("");
  const [guestId, setGuestId] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [widgetProps, setWidgetProps] = useState({});
  const [urlBackendWidget, setUrlBackendWidget] = useState(BE_API_URL);
  const [externalDimensions, setExternalDimensions] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const checkPreviewMode = () => {
    let checkPreviewRes = false;
    if (window.location.search && window.location.search !== "") {
      const appId = window.location.search.split("=");
      if (appId && appId.length && appId[1] === PREVIEW_APP_ID) {
        checkPreviewRes = true;
      }
    }
    return checkPreviewRes;
  };
  // search in query params for chaticon and its value
  const getQueryParams = window.location.search;
  const urlParams = new URLSearchParams(getQueryParams);
  const chaticon = urlParams.get("chaticon");

  const getSubDomain = async (sub) => {
    try {
      const subDomainConfig = await fetch(
        `${BE_API_URL}campaign?SUB-DOMAIN=${sub}`
      );
      if (subDomainConfig.ok) {
        const subDomainConfigRes = await subDomainConfig.json();

        if (
          subDomainConfigRes &&
          subDomainConfigRes?.subDomain === sub &&
          subDomainConfigRes?.status &&
          (subDomainConfigRes?.status.toLowerCase() === "published" ||
            checkPreviewMode())
        ) {
          if (window?.location?.search) {
            const searchParams = new URLSearchParams(window.location.search);
            const popup = searchParams.get("popup");
            const chaticon = searchParams.get("chaticon");

            let queryParamsObject = {};

            // Iterate through each parameter in URLSearchParams
            for (const [key, value] of urlParams) {
              queryParamsObject[key] = value;
            }

            subDomainConfigRes.utmParams = queryParamsObject;

            if (popup === "true") {
              const heightExternal = searchParams.get("h") || 320;
              const widthExternal = searchParams.get("w") || 250;
              const unit = searchParams.get("unit") || "false";
              if (unit === "true") {
                setExternalDimensions({
                  heightExternal: heightExternal,
                  widthExternal: widthExternal,
                });
              } else {
                setExternalDimensions({
                  heightExternal: `${heightExternal}px`,
                  widthExternal: `${widthExternal}px`,
                });
              }
            }
            // Add chaticon to widgetProps
            subDomainConfigRes.chaticon = chaticon === "true";
          }
          setWidgetProps(subDomainConfigRes);
          setUrlBackendWidget(`${BE_API_URL}chat?SUB-DOMAIN=${sub}&platform=${platform || 'web'}`);
          setAppIdProp(subDomainConfigRes.subDomain);
          setIsValid(true);
          setIsLoading(false);
        } else {
          setIsValid(false);
        }
      } else {
        setIsValid(false);
      }
    } catch (error) {
      setIsValid(false);
    }
  };

  useEffect(() => {
    // clevertap.event.push(values.subDomain+' Chatbot Opened');
    let storedGuestId = localStorage.getItem("guestId");
    if (!storedGuestId) {
      storedGuestId = uuidv4();
      localStorage.setItem("guestId", storedGuestId);
    }
    setGuestId(storedGuestId);

    const newUniqueId = uuidv4();
    setSessionId(newUniqueId);

    const hostname = window?.location?.hostname;
    const parts = hostname.split(".");
    const sub = parts.length > 2 ? parts[0] : "";

    if (sub && sub !== "") {
      setIsLoading(true);
      getSubDomain(sub); // Call getSubDomain API
    } else {
      setIsValid(false);
    }
  }, []);

  return !isValid ? (
    isLoading ? (
      ""
    ) : (
      <PageNotFound />
    )
  ) : (
    <div>
      <ChatWidget
        widgetConfig={widgetProps}
        urlApi={urlBackendWidget}
        headersApi={{
          "Content-Type": "application/json",
          "App-Id": appIdProp,
          "Session-Id": sessionId,
          "Guest-Id": guestId,
          "Campaign-Id": "NA",
        }}
        sessionId={sessionId}
        guestId={guestId}
        externalDimensions={externalDimensions}
      />
    </div>
  );
}

export default App;
